export enum PromptTypeEnum {
  String = "string",
  AILanguageModelPrompt = "ai-language-model-prompt",
  SequenceAILanguageModelPrompt = "sequence-ai-language-model-prompt",
}
